<template>
  <base-section
    id="phd-contest"
    space="0"
  >
    <v-card
      class="mx-auto"
      max-width="100%"
    >
      <v-img
        :src="require(`@/images/phdcontestwinner.png`)"
      />

      <v-card-title>
        SEBASTIAN HUHN
        <br>
        PhD Contest Winner ETS22
      </v-card-title>

      <v-card-actions>
        <v-btn
          color="primary"
          text
          @click="show1 = !show1"
        >
          Read More
        </v-btn>

        <v-spacer />

        <v-btn
          icon
          @click="show1 = !show1"
        >
          <v-icon>{{ show1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <div v-show="show1">
          <v-divider />

          <v-card-text>
            <strong>Thesis title</strong>: Next generation Design For Testability, Debug and Reliability Using Formal Techniques
            <br>
            <strong>Affiliation</strong>: University of Bremen, Germany
            <br>
            <strong>Paper abstract</strong>: The integration of Design for Testability (DFT) measures is strictly required when designing state-of-the-art Integrated Circuits (ICs) to ensure that good testability prevails in the resulting design. This testability allows performing high-quality manufacturing tests, which give a certain level of confidence that no defects had occurred during the manufacturing process.
            Such a defect possibly tampers the functional behavior’s correctness and, hence, leads to disastrous consequences in the
            field of safety-critical systems or, even within non-critical applications, to customer returns and a crucial loss of reputation. However, the steadily increasing design complexity yields a significant increase in the Test Data Volume (TDV) and, hence, the Test Application Time (TAT) during the circuit test, which both increase the test costs. This effect is even more amplified when generating tests for safety-critical applications like advanced driver assistance systems, enforcing a zero-defect policy as typically required in the automotive domain.
            Different test compression techniques were proposed in the literature allowing for a significant reduction of the TDV primarily during the high volume manufacturing test under certain conditions during the wafer test. However, these techniques are, for instance, not accessible during the Low-Pin Count Test or in later test phases like board-level or in-field testing. Thus,  high TAT results or specific tests are not applicable at all due to exceeded (tester) memory resources. In addition to these testability criteria, further requirements have to be met, for instance, the overall number of input and output pins at the chip-level, whose number heavily affects the resulting manufacturing costs.
            Besides these DFT measures, specific structures in the sense of Design for Debug and Diagnosis (DFD) are introduced since similar problems exist when debugging complex systems. Analogously to manufacturing defects, a transient fault occurring during the functional operation can lead to the same disastrous consequences, particularly when being involved in a safety-critical application scenario. Such a transient fault occurs in harsh environments like a high radiation level, which potentially invalidates the functional behavior.
            Different measures were proposed in the literature to protect a circuit against transient
            faults. Prominent candidates are the Triple Modular Redundancy and Razor II. These approaches hold a contradictory objective between low costs, reliable design and high-quality testing and, hence, new measures are required to achieve the required level of testability, debugging, and reliability of the resulting circuit.
            This dissertation introduces different measures for tackling some of the rising challenges in the field of design for testability, debug, and reliability, as strictly required for state-of-the-art circuit designs. In particular, this dissertation combines formal techniques, such as the Boolean satisfiability problem and the bounded model checking, to significantly reduce the resulting TDV & TAT and strongly enhance the reliability of the circuit against transient faults. All methods are discussed in detail and evaluated extensively while considering industry-relevant benchmark candidates.
            Furthermore, the proposed measures have been integrated into a common framework, which implements standardized software/hardware interfaces, and, hence, can be reused in an industrial environment that uses a commercial electronic design automation tool-flow.
          </v-card-text>
          <v-card-actions>
            <v-spacer />

            <v-btn
              icon
              @click="show1 = !show1"
            >
              <v-icon>{{ show1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
        </div>
      </v-expand-transition>
    </v-card>
  </base-section>
</template>
<script>
  export default {
    name: 'PhdContest',
    data: () => ({
      show1: false,
    }),
  }
</script>
